import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/library',
      name: 'Library',
      component: () => import('@/pages/Library'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/toc',
      name: 'TOC',
      component: () => import('@/pages/TOC'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/book/:id/:page?',
      name: 'Book',
      component: () => import('@/pages/Book'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/access-denied',
      name: 'AccessDenied',
      component: () => import('@/pages/AccessDenied'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      name: 'Login',
      component: () => import('@/pages/Login')
    },
    { // Backward compatibility
      // Handles links from old web reader
      path: '/open',
      redirect: to => {
        if (to.query.book) {
          return {name: 'Book', params: {id: to.query.book, page: to.query.page || 1}}
        }
        else {
          return {name: 'Library'}
        }
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.dispatch('user/checkToken')
      .then(user => {
        next()
      })
      .catch((err) => {
        localStorage.setItem('unAuthLastViewedURL', window.location)
        next({path: '/'})
      })
  } else {
    next()
  }
})

export default router
